// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__2rnrU","tagIcon":"Tag_tagIcon__3T7x_"};